import './Rooms.css';
import { roomsButtons } from '../Classic/constantsClassic';
import { Button } from '../../components/buttons/Button/Button';
import React, { Dispatch, SetStateAction, useState } from 'react';
import roomsBackgroundImg from '../../images/RoomsBackgroundImg.png';
import { CheckBox } from '../../components/shared/CheckBox/CheckBox';
import { Border } from '../../components/Border/Border';
import { Accordion } from './components/Accordion/Accordion';
import usePopup from '../../utils/hooks/usePopup';
import { CreateRoomPopup } from './components/CreateRoomPopup/CreateRoomPopup';
import { Title } from '../../components/Title/Title';

export const Rooms = ({ setIsInventoryOpen }: { setIsInventoryOpen: Dispatch<SetStateAction<boolean>> }) => {
    const [showPopup, togglePopup] = usePopup();
    const [createRoom, setCreateRoom] = useState<string>('');

    const [isBigOrder, setIsBigOrder] = useState<boolean>(false);
    const handleCheckboxChange = (checked: boolean) => {
        console.log('Checkbox checked:', checked);
        setIsBigOrder(checked);
    };

    const checkBoxId = 'exampleCheckbox';
    const checkBoxLabel = 'комнаты с тиммейтами сверху';
    const title = 'комнаты';

    return (
        <div className="rooms">
            <Title title={title} />
            <img src={roomsBackgroundImg} alt="" className="rooms__background-img" />
            <div className="rooms__background-text-container">
                <span className="rooms__background-text">
                    Мин. сумма скинов для ставки:
                    <span> 2.11 ₽.</span>
                </span>
                <span className="rooms__background-text">
                    Максимум 30 скинов. Ставки примерно равны
                    <span> (±10%).</span>
                </span>
            </div>
            <div className="rooms__secure-container">
                {roomsButtons.map((item, i) => (
                    <Button link={item.link} key={i} icon={item.icon} />
                ))}
            </div>
            <div className="rooms__settings-container">
                <span className="rooms__settings-text">
                    Сначала большие ставки
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                        <path
                            fill="#B8B8B8"
                            d="M4.884 7.793a1.035 1.035 0 0 1-.632-.316l-3.24-3.39C.557 3.61.882 2.8 1.53 2.8h6.94c.647 0 .973.81.518 1.287l-3.24 3.39A1.032 1.032 0 0 1 5 7.8z"
                            opacity=".6"
                        />
                    </svg>
                </span>
                <form action="" className="rooms__settings-form">
                    <CheckBox id={checkBoxId} label={checkBoxLabel} checked={isBigOrder} onChange={handleCheckboxChange} />
                </form>

                <button onClick={togglePopup} className="rooms__button-change ">
                    Создать комнату
                    {showPopup && <CreateRoomPopup setCreateRoom={setCreateRoom} />}
                </button>
            </div>
            <Border />
            <div className="rooms__accordion-container">
                <Accordion setIsInventoryOpen={setIsInventoryOpen} />
                <Accordion setIsInventoryOpen={setIsInventoryOpen} />
                <Accordion setIsInventoryOpen={setIsInventoryOpen} />
                <Accordion setIsInventoryOpen={setIsInventoryOpen} />
                <Accordion setIsInventoryOpen={setIsInventoryOpen} />
                <Accordion setIsInventoryOpen={setIsInventoryOpen} />
                <Accordion setIsInventoryOpen={setIsInventoryOpen} />
                <Accordion setIsInventoryOpen={setIsInventoryOpen} />
                <Accordion setIsInventoryOpen={setIsInventoryOpen} />
                <Accordion setIsInventoryOpen={setIsInventoryOpen} />
                <Accordion setIsInventoryOpen={setIsInventoryOpen} />
            </div>
        </div>
    );
};
